<wb-side-dialog [open]="$isOpen()" [mode]="$mode()" width="440px" (closed)="onSideDialogClosed()">
  <wb-settings-panel [panel]="panel()" [dismissOnClickOutside]="$mode() !== 'push'" (closed)="requestClose()" />
</wb-side-dialog>
